import {
  EcommerceEmailsSettingsAction,
  LOAD_ECOMMERCE_EMAILS_SETTINGS,
  LOAD_ECOMMERCE_EMAILS_SETTINGS_FAIL,
  LOAD_ECOMMERCE_EMAILS_SETTINGS_SUCCESS,
  LoadEcommerceEmailsSettings,
  LoadEcommerceEmailsSettingsFail,
  LoadEcommerceEmailsSettingsSuccess,
} from "../actions";

export interface IEcommerceEmailsSettingsEntityState {
  data: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceEmailsSettingsState {
  entities: { [websiteId: number]: IEcommerceEmailsSettingsEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceEmailsSettingsState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceEmailsSettingsState = initialState, action: EcommerceEmailsSettingsAction): IEcommerceEmailsSettingsState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_EMAILS_SETTINGS:
      payload = (<LoadEcommerceEmailsSettings>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_EMAILS_SETTINGS_SUCCESS:
      payload = (<LoadEcommerceEmailsSettingsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            data: payload.data,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_EMAILS_SETTINGS_FAIL:
      payload = (<LoadEcommerceEmailsSettingsFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
